import { CommonModule } from '@angular/common'
import { Component, output, ChangeDetectionStrategy } from '@angular/core'
import { RouterLink, RouterLinkActive, RouterModule } from '@angular/router'
import { SpanishDirective } from '@baboor/baboor-language'
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco'

@Component({
    selector: 'app-easy-mobile-nav',
    imports: [RouterModule, CommonModule, TranslocoModule, SpanishDirective],
    templateUrl: './easy-mobile-nav.component.html',
    styleUrl: './easy-mobile-nav.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [provideTranslocoScope('vendorDashboard')],
})
export class EasyMobileNavComponent {
    menuClick = output<void>()

    onMenuClick() {
        this.menuClick.emit()
    }
}
